module.exports = __webpack_public_path__ + "img/text_book.5f00fa60.png";